import {useState, useEffect} from 'react'
import Banner from '../../components/Banner/Banner'
import { Link } from "react-router-dom";
import Card from '../../components/CourseCard/Card'
import {  getCourseData } from '../../courseData'
import './Home.css'


const Home = () => {

  const content = () => {

      return (
        <div>
          
          <Banner />
    
          <div className='HomeContainer'>
            <h1 className='Heading'>Courses</h1>
            <p className='FirstLine'>View the Best Online Courses Now!</p>

            
    
            <div className='ItemDesc'>
              {courses.slice(0, 11).map((course: { _id: string; name: string; price: number; image: { Location: string }; category: string; paid: string; instructor:{name: string} },key:string) => {
                
                return (
                  <Link to={`/courses/${course.name}`} key={course._id}>
                    <Card
                      key={course._id}
                      name={course.name}
                      instructor={course.instructor}
                      price={0}
                      category={course.category}
                      image={course.image?.Location} />
                  </Link>
                );
              })}
            </div>
            <Link to={"/courses"}>Browse More...</Link>
          </div>
          
          
        </div>
      )
      
    
  }
  interface CoursesProps{
    id?: number,
    name?: string,
    price?: number,
    image?: {Location: string},
    category?: string,
    instructor?: string;
    
  }

  //adding CoursesProps in generic type causes an error without any
  const [courses, setCourses] = useState<CoursesProps | any>([]);
  useEffect(() => { 
    (async () => setCourses(await getCourseData()))();
    
  }, []);


  

  return (
    <div>
      {content()}
    </div>
  )
}

export default Home


